export default "__VITE_ASSET__DJxVvykj__"